var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c-.006-5.52-4.48-9.994-10-10z",
    fill: "#E95832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.273 6.833l-5.704 7.741a.843.843 0 01-1.192.157l-4.074-3.257a.833.833 0 111.042-1.302l3.397 2.718 5.189-7.043a.833.833 0 111.342.986z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/checkIcon.6d469ec1.svg";
export { SvgCheckIcon as ReactComponent };